import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'

// 认证页面
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import LandingPage from './pages/LandingPage'

// 业务页面
import DealDashboard from './pages/DealDashboard'
import DealDetail from './pages/DealDetail'

// 协作页面
import InviteAcceptPage from './pages/InviteAcceptPage'

// 受保护路由
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  const { initialize } = useAuthStore()
  
  // 初始化认证状态
  useEffect(() => {
    initialize()
  }, [initialize])
  
  return (
    <BrowserRouter>
      <Routes>
        {/* 公开路由 */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        
        {/* 邀请接受页面（可公开访问，但接受需登录） */}
        <Route path="/invite/:token" element={<InviteAcceptPage />} />
        
        {/* 受保护路由 */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <div className="min-h-screen bg-gray-50">
                <DealDashboard />
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/deal/:dealId"
          element={
            <ProtectedRoute>
              <div className="min-h-screen bg-gray-50">
                <DealDetail />
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
